module.exports = __webpack_public_path__ + "img/kerry_big.054b3a9a.jpg";